<template>
  <div>
    <div id="paypal-button-container"></div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { PayPal } from "../utils/constants";
import { appendSubscriptionEventLog } from "../utils/log";
import { resolveBillingInfo } from "../utils/subscription";

export default {
  name: "PayPalButton",

  data() {
    return {
      planId: PayPal.planId,
    };
  },
  async mounted() {
    // await this.checkSubscriptionStatus(); // Check if user is already subscribed
    this.loadPayPalScript();
  },
  beforeUnmount() {
    document.getElementById("paypal-button-container").innerHTML = "";
  },
  methods: {
    // Dynamically load the PayPal SDK with client-id from environment variables
    loadPayPalScript() {
      if (document.querySelector('script[src*="paypal.com/sdk/js"]')) {
        this.renderPayPalButton();
        return;
      }
      const scriptTag = document.createElement("script");
      scriptTag.src = `https://www.paypal.com/sdk/js?client-id=${PayPal.sdkClientId}&vault=true&intent=subscription`;
      scriptTag.onload = () => {
        this.renderPayPalButton();
      };
      scriptTag.onerror = () => {
        console.error("Failed to load PayPal script.");
      };

      document.head.appendChild(scriptTag);
    },

    renderPayPalButton() {
      if (typeof window.paypal === "undefined") {
        console.error("PayPal SDK not loaded.");
        return;
      }
      window.paypal
        .Buttons({
          style: {
            shape: "rect",
            color: "gold",
            layout: "vertical",
            label: "subscribe", // Subscription-specific label
          },
          createSubscription: (data, actions) => {
            return actions.subscription.create({
              plan_id: this.planId, // Pass the plan ID from props
            });
          },
          onApprove: async (subscriptionData, actions) => {
            // Handle successful subscription
            const { facilitatorAccessToken, subscriptionID } = subscriptionData;
            const user = await Auth.currentAuthenticatedUser();

            const attributes = {
              "custom:subscriptionID": subscriptionID, // Storing subscription ID as PayPal Customer Number
              "custom:pro": "active",
            };

            await Auth.updateUserAttributes(user, attributes);
            this.$store.dispatch("setSubStatus", "active");
            this.$store.dispatch("setSubID", subscriptionID);
            this.$store.dispatch("setUserToken", facilitatorAccessToken);
            this.$store.dispatch("setDeleteDialog", {});

            let nextBilling = "";
            let lastPayment = "";
            try {
              const info = await resolveBillingInfo(subscriptionID, facilitatorAccessToken);
              nextBilling = info.nextBilling || "unknown";
              lastPayment = info.lastPayment || lastPayment;
              if (nextBilling) {
                this.$store.dispatch("setNextBillingTime", { nextBillingTime: info.nextBillingRaw || nextBilling });
              }
              if (lastPayment && lastPayment !== "unknown") {
                const refreshedUser = await Auth.currentAuthenticatedUser();
                await Auth.updateUserAttributes(refreshedUser, { "custom:lastPayment": lastPayment });
                this.$store.dispatch("setLastPayment", lastPayment);
              }
            } catch (e) {
              console.error("Failed to fetch subscription details on approval:", e);
            }

            this.$store.dispatch("addToast", {
              severity: "success",
              life: 3000,
              summary: "Subscribed",
              detail: "You successfully subscribed to pro plan.",
            });
            appendSubscriptionEventLog({
              eventType: "subscription",
              validUntil: nextBilling,
              status: "active",
              subscriptionId: subscriptionID,
              lastPayment,
            });
          },
          onError: (err) => {
            console.error("PayPal Subscription Error:", err);
            this.$store.dispatch("setSubStatus", "inactive");
            this.$store.dispatch("setSubID", "");
            this.$store.dispatch("setDeleteDialog", {});
            this.$store.dispatch("addToast", {
              severity: "error",
              life: 3000,
              summary: "Subscription failed",
              detail: "Subscription failed. Please try again.",
            });
          },
        })
        .render("#paypal-button-container");
    },
  },
};
</script>
